// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CitationBlock_wrapper__6Q7fR","img":"CitationBlock_img__i_41t","heading":"CitationBlock_heading__nMsdL","description":"CitationBlock_description__RDTA4"};